module.exports = __webpack_public_path__ + "img/my-cards-background.9f3d0616.svg";